(function() {
  'use strict';

  angular
    .module('app.notification')
    .factory('ProductUptimeService', ProductUptimeService);

  ProductUptimeService.$inject = [
    '$state',
    '$rootScope',
    'APP_CONSTANTS',
    'ApiCaller',
    '$window',
    '$stateParams',
    '$q',
    '$filter'
  ];

  function ProductUptimeService(
    $state,
    $rootScope,
    APP_CONSTANTS,
    ApiCaller,
    $window,
    $stateParams,
    $q,
    $filter
  ) {
    var self = this;

    self.sendNotification = sendNotification;

    function sendNotification(notificationContent) {
      var deferred = $q.defer();
      var url = $filter('sprintf')(
        APP_CONSTANTS.notificationCollection,
        APP_CONSTANTS.rootUrl
      );

      ApiCaller.apiPost(url, notificationContent).then(
        function(result) {
          deferred.resolve(result);
        },
        function(err) {
          deferred.reject(err);
        }
      );

      return deferred.promise;
    }

    return self;
  }
})();
